import React from 'react'

import { Box } from '@chakra-ui/react'

import { MAX_DESCRIPTION_LENGTH } from 'src/components/features/EditItList'
import TextArea from 'src/components/widgets/TextArea/TextArea'
import { MAX_LG_INPUT } from 'src/lib/constants'

import { TypeBuilderProps } from '../..'

const Builder: React.FC<TypeBuilderProps> = () => {
  return (
    <Box mt={4} w="full">
      <TextArea
        w="full"
        mb={4}
        name="text.heading"
        placeholder="Heading"
        maxLength={MAX_LG_INPUT}
        withCounter={true}
        data-testid="textBuilder-heading"
      />
      <TextArea
        w="full"
        name="text.description"
        placeholder="Description"
        maxLength={MAX_DESCRIPTION_LENGTH}
        withCounter={true}
        hideCounterMax={1500}
        data-testid="textBuilder-description"
        autoExpand={true}
      />
      <Box className="body-extra-small" color="stone" mt={1}>
        Add a section heading, description, or both.
      </Box>
    </Box>
  )
}

export default Builder
